var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageaccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 6.5H7.33333C6.59695 6.5 6 7.09695 6 7.83333V17.1667C6 17.903 6.59695 18.5 7.33333 18.5H16.6667C17.403 18.5 18 17.903 18 17.1667V7.83333C18 7.09695 17.403 6.5 16.6667 6.5Z",
    stroke: "#DDDEE0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91797 12C10.6083 12 11.168 11.4404 11.168 10.75C11.168 10.0596 10.6083 9.5 9.91797 9.5C9.22761 9.5 8.66797 10.0596 8.66797 10.75C8.66797 11.4404 9.22761 12 9.91797 12Z",
    fill: "#DDDEE0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9987 14.5003L14.6654 11.167L7.33203 18.5003",
    stroke: "#DDDEE0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 23.25H20C21.5188 23.25 22.75 22.0188 22.75 20.5V15.5H21.25V20.5C21.25 21.1904 20.6904 21.75 20 21.75H15V23.25ZM15 3.25H20C20.6904 3.25 21.25 3.80964 21.25 4.5V9.5H22.75V4.5C22.75 2.98122 21.5188 1.75 20 1.75H15V3.25ZM9 1.75V3.25H4C3.30964 3.25 2.75 3.80964 2.75 4.5V9.5H1.25V4.5C1.25 2.98122 2.48122 1.75 4 1.75H9ZM9 21.75V23.25H4C2.48122 23.25 1.25 22.0188 1.25 20.5V15.5H2.75V20.5C2.75 21.1904 3.30964 21.75 4 21.75H9Z",
    fill: "#DDDEE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageaccess);
export default __webpack_public_path__ + "static/media/imageaccess.8200ad058a0415efb2c08993978d9fd1.svg";
export { ForwardRef as ReactComponent };